module.exports = __webpack_public_path__ + "static/media/06.bb49e485.jpg";